import { RouteLocationRaw } from 'vue-router';
import router from '@/router';

export const goBack = (fallbackTo: RouteLocationRaw) => {
    window.history.state.back ? router.back() : router.push(fallbackTo);
};
